export const matchRange = (range: string): [string, string, string, string] => {
  const r = /([A-Z]*)([0-9]+):([A-Z]*)([0-9]+)/g;
  const [_, colStart, rowStart, colEnd, rowEnd] = r.exec(range);

  return [colStart || 'A', rowStart || '0', colEnd, rowEnd];
};
